import { intl } from '@approvalmax/utils';
import { calculateCisDeductionInvoice } from 'pages/requestForm/selectors/xero/cisDeductionUtils';
import { memo } from 'react';
import { SummaryLineValues } from 'shared/components';

import { messages } from './XeroCisDeductionInvoice.messages';
import { XeroCisDeductionInvoiceProps } from './XeroCisDeductionInvoice.types';

export const XeroCisDeductionInvoice = memo<XeroCisDeductionInvoiceProps>((props) => {
    const { cisRate, lineAmountType, lineItems, currency } = props;

    const cisTaxAmount = calculateCisDeductionInvoice(lineItems, cisRate, lineAmountType);

    if (typeof cisTaxAmount !== 'number') {
        return null;
    }

    return (
        <SummaryLineValues
            label={messages.cisTaxAmount({ percent: cisRate })}
            value1={intl.formatCurrency(cisTaxAmount, currency)}
        />
    );
});

XeroCisDeductionInvoice.displayName = 'XeroCisDeductionInvoice';
